import { api } from '@services';

import Organization, {
  IOrganization,
  IOrganizationApiModel,
} from '@models/Organization.model';

const getOrganizationById = async (id: string): Promise<IOrganization> => {
  const { data: organization } = await api.get<IOrganizationApiModel>(
    `/auth0/organizations/id/${id}`,
  );

  return Organization.fromApiModel(organization);
};

export { getOrganizationById };
